export const updateStatus = (payload) => (dispatch, getState) => {
  dispatch({
    type: 'UPDATE_STATUS',
    payload
  })
}